import { AppHeader } from "@/components/app-header";
import { AppSidebar } from "@/components/app-sidebar";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import { getCookie } from "@/lib/utils";
import { Outlet } from "react-router-dom";

const Layout = () => {
    const defaultOpen = getCookie("sidebar:state") || "true";
    return (
        <>
            <SidebarProvider defaultOpen={defaultOpen == "true"}>
                    <AppSidebar />
                    <SidebarInset>
                        <AppHeader />
                        <Outlet/>
                    </SidebarInset>
                </SidebarProvider>
            <Toaster richColors closeButton />
        </>
    );
};

export default Layout;
